import { render, staticRenderFns } from "./jv_eliminasi_template.vue?vue&type=template&id=2743e2a4"
import script from "./jv_eliminasi_template.vue?vue&type=script&lang=js"
export * from "./jv_eliminasi_template.vue?vue&type=script&lang=js"
import style0 from "./jv_eliminasi_template.vue?vue&type=style&index=0&id=2743e2a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports